"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var satcheljs_1 = require("satcheljs");
var initialSurfaceActionsStore = {
    isAddinObserverLoaded: false,
};
var store = satcheljs_1.createStore('SurfaceActionsStore', initialSurfaceActionsStore)();
exports.default = store;
//# sourceMappingURL=store.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-surface-actions/lib/store/store.js
// module id = 2729
// module chunks = 2 3 4